export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 border-t border-background-200/20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-3 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-950 text-base"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-50">桃子影院</span>
            </a>
            <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
              电影大全 · 最新电影 · 热门电影排行榜 · 华语电影在线观看。
              永久免费不缓冲，高清超清蓝光4K影视秒开播放。
            </p>
          </div>

          <div>
            <div className="text-sm font-semibold text-foreground-100 mb-3">快速导航</div>
            <div className="flex flex-col gap-2">
              <a href="#ranking" className="text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热播排行榜</a>
              <a href="#faq" className="text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              <a href="#index" className="text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">专题合集</a>
              <a href="#about" className="text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold text-foreground-100 mb-3">影片分类</div>
            <div className="flex flex-col gap-2">
              <a href="#cards" className="text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">精选推荐</a>
              <a href="#topics" className="text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门话题</a>
              <a href="#carousel" className="text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">焦点专题</a>
              <a href="#media" className="text-xs md:text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">精彩片段</a>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold text-foreground-100 mb-3">合作伙伴</div>
            <div className="flex flex-col gap-2">
              <span className="text-xs md:text-sm text-foreground-600">更多合作伙伴即将加入</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/20 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 桃子影院 · 永久免费在线电影观看平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">回到顶部</a>
            <a href="#contact" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            <a href="#faq" className="text-xs text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}